import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Dropdown, Image, Nav, Navbar, Spinner } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { backendAddress } from '../config';
import { initSocket } from '../Socket/SocketManager';

export const MainNavBar: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [failed, setFailed] = useState<boolean>(false);
  const [user, setUser] = useState<{ id: number, username: string, name: string, image: string } | undefined>(undefined);

  const [onlineCount, setOnlineCount] = useState<any | undefined>(undefined);

  const history = useHistory();

  async function loadUserSession(key: string) {

    try {

      const response = await fetch(`${backendAddress}/login/session?session_id=` + key, {
        method: 'GET'
      });

      if (response.status === 401 || response.status === 400) {
        sessionStorage.removeItem("session_id");
        setLoading(false);
        setUser(undefined);
        setFailed(false);
        history.replace("/");
        return;
      }

      const data = await response.json();

      setUser(data);
      setLoading(false);

    } catch (error) {
      setFailed(true);
    }

  }

  useEffect(() => {

    const key = sessionStorage.getItem("session_id");

    initSocket(setOnlineCount);

    if (key === null) {
      setLoading(false);
      return;
    }

    loadUserSession(key);

  }, []);

  return (
    <Navbar bg="dark" id={"MainNavbar"}>
      <Navbar.Brand as={Link} to="/" className="text-light">advanced tic tac toe</Navbar.Brand>
      {(onlineCount !== undefined) && <Nav className="text-info">
        {onlineCount} player online
      </Nav>}
      <Nav className="mr-auto">
        {/* <Nav.Link className="text-light" as={Link} to="/">Home</Nav.Link> */}
      </Nav>
      <AuthenticationButton user={user} loading={loading} failed={failed} />
    </Navbar>
  );

}

interface AuthenticationButtonProps {
  user: { id: number, username: string, name: string, image: string } | undefined;
  loading?: boolean;
  failed?: boolean
}

const AuthenticationButton: React.FC<AuthenticationButtonProps> = ({ user, loading, failed }) => {

  if (failed) return (<>login failed</>);

  if (loading) return (<Spinner animation="border" />);

  return (
    <>
      {(user === undefined) ?
        <ButtonGroup>
          <Button as={Link} to="/login" variant="secondary">sign in</Button>
          {/* <Button as={Link} to="/signup" variant="success">sign up</Button> */}
        </ButtonGroup>
        :
        <>
          <Dropdown>
            <Dropdown.Toggle variant="dark" >
              {user.username + " "}
              <Image style={{ height: "30px" }} src={user.image} roundedCircle />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-right">
              <Dropdown.Item >logged in as {user.username}</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item>logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </>
      }
    </>
  );

}
